export default __webpack_public_path__ + "static/media/icon-line-v2.ae705121.svg";